'use strict';

var $    					= require('jquery');
var Core 					= require('../core/core.js');
var InspectorColorSwatch = require('./inspector__colorpicker__swatch.js');

/**
 * Creates an colorswatch div. made to be used inside the inspector.
 * make sure to populate with color items
 *
 * @class
 */

class InspectorColorSwatchRow extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
      <div class='editor__inspector__colorswatch__row'></div>
		`;

		super.render();
	}

  addColor(hexString) {
    return new InspectorColorSwatch({
      target: this.$el,
      fields: {
        'color': hexString
      }
    });
  }

}
module.exports = InspectorColorSwatchRow;
